<template>
  <p v-if="author || lastUpdate" class="content-page-meta">
    <span v-if="author">
      {{ tr("main_site.page_info.author_prefix") }} {{ author }}
    </span>
    <span v-if="author && lastUpdateLabel" aria-hidden="true"> · </span>
    <span v-if="lastUpdateLabel">
      {{ tr("main_site.page_info.last_update_prefix") }}
      {{ lastUpdateLabel }}
    </span>
  </p>
</template>

<script setup lang="ts">
import { computed } from "vue";

import {
  injectI18nLocale,
  localeToIso,
  useI18nMainSiteCms,
} from "@solvari/translations";

const props = withDefaults(
  defineProps<{
    author?: string | null;
    lastUpdate?: string | null;
  }>(),
  {
    author: null,
    lastUpdate: null,
  },
);

const { tr } = useI18nMainSiteCms();
const locale = injectI18nLocale();

const lastUpdateLabel = computed(() => {
  if (!props.lastUpdate) {
    return null;
  }
  // Not dayjs: ProductPageHeader imports this eagerly, which would pull in 22 kB.
  return new Intl.DateTimeFormat(localeToIso(locale.value), {
    month: "long",
    year: "numeric",
  }).format(new Date(props.lastUpdate));
});
</script>

<style lang="postcss">
.content-page-meta {
  @apply text-sm text-slate-600;
}
</style>
